import * as React from 'react';

import * as _ from 'lodash';

import { usePreferences } from './preferences';

export type Settings = Readonly<{
    servicesUrl: string;
    culture?: string;
}>

export const SettingsContext = React.createContext<[ Settings, React.Dispatch<React.SetStateAction<Settings>> ] | null>(null);

export interface SettingsProviderProps {
}
export function SettingsProvider({ children }: React.PropsWithChildren<SettingsProviderProps>) {
    const state = React.useState<Settings>(loadSettings());
    React.useEffect(() => {
        setSettings(state[0]);
    }, [ state[0] ]);

    return (
        <SettingsContext.Provider value={state}>
            {children}
        </SettingsContext.Provider>
    )
}
export function useSettings() {
    const state = React.useContext(SettingsContext);
    if (!state)
        throw new Error('No settings provider declared');

    return state;
}

function loadSettings(): Settings {
    const content = window.localStorage.getItem('gnosis.settings');
    if (!content) {
        return {
            servicesUrl: 'http://localhost:9080'
        };
    }

    return JSON.parse(content);
}
function setSettings(settings: Settings) {
    window.localStorage.setItem('gnosis.settings', JSON.stringify(settings));
}